import { BarChart, Bar, XAxis, YAxis } from "recharts";

import { getChartColor, prepareChartData } from "../helpers/functions";

export default function StandardBarChart({ chart, children }) {
  const { data, dimensions, measures } = prepareChartData(chart);
  return (
    <BarChart data={data}>
      {dimensions.map((axis) => (
        <XAxis dataKey={axis?.data_key} key={axis?.data_key} />
      ))}
      {measures.map((measure, idx) => (
        <Bar
          type="monotone"
          dataKey={measure?.data_key}
          key={`${measure?.data_key}-${idx}`}
          name={measure?.label || "Count"}
          barSize={100}
          fill={getChartColor(idx)}
        />
      ))}
      <YAxis />
      {children}
    </BarChart>
  );
}
